import React from 'react';

export const plainTextOrElement = (text, plainText) =>
  plainText ? text : <>{text}</>;
